// THE PERSON CALLED RINGS (functions/incomingCall.js; Nika 2026-10-23: "add
// calling mode into fly so you can call to anyone in workspace"). The meeting
// invite's own card (components/CallInvitationBanner.js — one card for both
// ways a call reaches someone): "Incoming call", the caller's name, Join call
// and Decline. Its scan runs on its own updates — rooms landing through meet's
// realtime and the invite banner's 30 s tick, which lets a ring expire.
export const IncomingCallBanner = {
  extends: 'CallInvitationBanner',
  subscribeTo: ['rooms', 'activeRoomId', '_callRing', 'people', '_meetingInviteTick'],
  onRender: (el, s) => el.call('incomingCallScan', el, s),
  onUpdate: (el, s) => el.call('incomingCallScan', el, s),

  Card: {
    hide: (el, s) => !el.call('incomingCallOf', s.root),
    'aria-label': (el) => el.call('polyglot', 'workspace.callPanel.incoming'),

    Header: {
      Lead: {
        Icon: { name: 'phone' },
        Eyebrow: { text: '{{ workspace.callPanel.incoming | polyglot }}' }
      },
      Dismiss: {
        title: (el) => el.call('polyglot', 'workspace.callPanel.action.decline'),
        'aria-label': (el) => el.call('polyglot', 'workspace.callPanel.action.decline'),
        onClick: (e, el) => {
          e.stopPropagation()
          el.call('incomingCallDecline')
        }
      }
    },

    Title: {
      text: (el, s) => (el.call('incomingCallOf', s.root) || {}).callerName || ''
    },

    Meta: {
      text: (el) => el.call('polyglot', 'workspace.callPanel.calling')
    },

    Actions: {
      Join: {
        text: '{{ workspace.callInvite.join | polyglot }}',
        onClick: (e, el) => {
          e.stopPropagation()
          el.call('incomingCallJoin')
        }
      }
    }
  }
}
